<!-- Topbar Start -->
<div class="topbar-custom">
  <div class="container-fluid">
    <div class="d-flex justify-content-between">
      <ul class="list-unstyled topnav-menu mb-0 d-flex align-items-center">
        <li>
          <button (click)="onToggleSidebar()" class="button-toggle-menu nav-link">
            <i data-feather="menu" class="noti-icon"></i>
          </button>
        </li>
        <li class="d-none d-lg-block">
          <h5 class="mb-0">{{ greetingMessage }}, {{authUser?.first_name || 'User'}}</h5>
        </li>
      </ul>

      <ul class="list-unstyled topnav-menu mb-0 d-flex align-items-center">
        <!-- <li class="d-none d-lg-block">
            <select
                    class="datatable-selector"
                    [(ngModel)]="systemLanguage"
                    (ngModelChange)="changeSystemLanguage($event)"
                    name="per-page"
            >
                <option value="en">English</option>
                <option value="es">Spanish</option>
            </select>
        </li> -->
        <li class="d-none d-sm-flex">
          <button (click)="openFullscreen()" type="button" class="btn nav-link" data-toggle="fullscreen">
            <i id="fullscreen-icon" class="align-middle fullscreen noti-icon"
              [attr.data-feather]="isFullscreen ? 'minimize' : 'maximize'"></i>
          </button>
        </li>
        <li class="d-none d-sm-flex">
          <button type="button" class="btn nav-link" (click)="changeTheme()" id="light-dark-mode">
            <i id="theme-icon" class="align-middle" [attr.data-feather]="theme === 'light' ? 'sun' : 'moon'"></i>
          </button>
        </li>
        <li class="dropdown notification-list topbar-dropdown" ngbDropdown>
          <!-- <a class="nav-link dropdown-toggle" ngbDropdownToggle data-bs-toggle="dropdown" href="javascript:void(0);"
            role="button" aria-haspopup="false" aria-expanded="false">
            <i data-feather="bell" class="noti-icon"></i>
            <span class="badge bg-danger rounded-circle noti-icon-badge">9</span>
          </a> -->
          <div class="dropdown-menu dropdown-menu-end dropdown-lg" ngbDropdownMenu>
            <!-- item-->
            <div class="dropdown-item noti-title">
              <h5 class="m-0">
                <span class="float-end">
                  <a href="" class="text-dark">
                    <small>Clear All</small>
                  </a> </span>Notification
              </h5>
            </div>

            <ngx-simplebar class="noti-scroll">
              <!-- item-->
              <a href="javascript:void(0);" class="dropdown-item notify-item text-muted link-primary active">
                <div class="notify-icon">
                  <img src="assets/images/users/user-12.jpg" class="img-fluid rounded-circle" alt="" />
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <p class="notify-details">Carl Steadham</p>
                  <small class="text-muted">5 min ago</small>
                </div>
                <p class="mb-0 user-msg">
                  <small class="fs-14">Completed
                    <span class="text-reset">Improve workflow in Figma</span></small>
                </p>
              </a>

              <!-- item-->
              <a href="javascript:void(0);" class="dropdown-item notify-item text-muted link-primary">
                <div class="notify-icon">
                  <img src="assets/images/users/user-2.jpg" class="img-fluid rounded-circle" alt="" />
                </div>
                <div class="notify-content">
                  <div class="d-flex align-items-center justify-content-between">
                    <p class="notify-details">Olivia McGuire</p>
                    <small class="text-muted">1 min ago</small>
                  </div>

                  <div class="d-flex mt-2 align-items-center">
                    <div class="notify-sub-icon">
                      <i class="mdi mdi-download-box text-dark"></i>
                    </div>

                    <div>
                      <p class="notify-details mb-0">dark-themes.zip</p>
                      <small class="text-muted">2.4 MB</small>
                    </div>
                  </div>
                </div>
              </a>

              <!-- item-->
              <a href="javascript:void(0);" class="dropdown-item notify-item text-muted link-primary">
                <div class="notify-icon">
                  <img src="assets/images/users/user-3.jpg" class="img-fluid rounded-circle" alt="" />
                </div>
                <div class="notify-content">
                  <div class="d-flex align-items-center justify-content-between">
                    <p class="notify-details">Travis Williams</p>
                    <small class="text-muted">7 min ago</small>
                  </div>
                  <p class="noti-mentioned p-2 rounded-2 mb-0 mt-2">
                    <span class="text-primary">&#64;Patryk</span> Please make
                    sure that you're....
                  </p>
                </div>
              </a>

              <!-- item-->
              <a href="javascript:void(0);" class="dropdown-item notify-item text-muted link-primary">
                <div class="notify-icon">
                  <img src="assets/images/users/user-8.jpg" class="img-fluid rounded-circle" alt="" />
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <p class="notify-details">Violette Lasky</p>
                  <small class="text-muted">5 min ago</small>
                </div>
                <p class="mb-0 user-msg">
                  <small class="fs-14">Completed
                    <span class="text-reset">Create new components</span></small>
                </p>
              </a>

              <!-- item-->
              <a href="javascript:void(0);" class="dropdown-item notify-item text-muted link-primary">
                <div class="notify-icon">
                  <img src="assets/images/users/user-13.jpg" class="img-fluid rounded-circle" alt="" />
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <p class="notify-details">Ralph Edwards</p>
                  <small class="text-muted">5 min ago</small>
                </div>
                <p class="mb-0 user-msg">
                  <small class="fs-14">Completed
                    <span class="text-reset">Improve workflow in React</span></small>
                </p>
              </a>

              <!-- item-->
              <a href="javascript:void(0);" class="dropdown-item notify-item text-muted link-primary">
                <div class="notify-icon">
                  <img src="assets/images/users/user-6.jpg" class="img-fluid rounded-circle" alt="" />
                </div>
                <div class="notify-content">
                  <div class="d-flex align-items-center justify-content-between">
                    <p class="notify-details">Jocab jones</p>
                    <small class="text-muted">7 min ago</small>
                  </div>
                  <p class="noti-mentioned p-2 rounded-2 mb-0 mt-2">
                    <span class="text-reset">&#64;Patryk</span> Please make sure
                    that you're....
                  </p>
                </div>
              </a>
            </ngx-simplebar>

            <!-- All-->
            <a href="javascript:void(0);" class="dropdown-item text-center text-primary notify-item notify-all">
              View all
              <i class="fe-arrow-right"></i>
            </a>
          </div>
        </li>

        <li class="dropdown notification-list topbar-dropdown" ngbDropdown>
          <a class="nav-link dropdown-toggle nav-user me-0" ngbDropdownToggle data-bs-toggle="dropdown"
            href="javascript:void(0);" role="button" aria-haspopup="false" aria-expanded="false">
            <img
              [src]="
                authUser?.profile_image
                  ? authUser.profile_image
                  : authUser?.gender === 1
                    ? 'assets/images/users/male.jpg'
                    : authUser?.gender === 2
                      ? 'assets/images/users/female.jpg'
                      : 'assets/images/users/user-24.png'
              "
              alt="user-image"
              class="rounded-circle"
            />
            <span class="pro-user-name ms-1">
              {{authUser?.first_name || 'User'}} <i class="mdi mdi-chevron-down"></i>
            </span>
          </a>
          <div class="dropdown-menu dropdown-menu-end profile-dropdown" ngbDropdownMenu>
            <!-- item-->
            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">Welcome !</h6>
            </div>

            <!-- item--> 
            <a routerLink="/profile" class="dropdown-item notify-item">
              <i class="mdi mdi-account-circle-outline fs-16 align-middle"></i>
              <span>My Account</span>
            </a>

            <!-- item-->
            <a routerLink="/auth/lock-screen" class="dropdown-item notify-item">
              <i class="mdi mdi-lock-outline fs-16 align-middle"></i>
              <span>Lock Screen</span>
            </a>

            <div class="dropdown-divider"></div>

            <!-- item-->
            <a routerLink="#" class="dropdown-item notify-item" (click)="logout()">
              <i class="mdi mdi-location-exit fs-16 align-middle"></i>
              <span>Logout</span>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
<!-- end Topbar -->